<template>
  <div>
    <certificado-card
      v-for="cert in certificados"
      :key="cert.id"
      :certificado="cert"
    />
  </div>
</template>

<script>
import CertificadoCard from '@/components/certificados/CertsCard.vue'

export default {
  name: 'CertificadosPanel',

  components: {
    CertificadoCard
  },

  props: {
    certificados: {
      type: Array,
      default: () => []
    }
  }
}
</script>
